import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from "@mui/material/IconButton";
import { forwardRef } from "react";

export type IconButtonProps = MuiIconButtonProps & {
  hoverColor?: string;
  dataDogIdentifier: string;
  loading?: boolean;
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { children, title, hoverColor, sx, dataDogIdentifier, loading, ...props },
  ref
) {
  const styles = hoverColor
    ? {
        "& svg": {
          transition: "color 0.2s"
        },
        "&:hover svg": {
          color: hoverColor
        },
        ...sx
      }
    : sx;

  return (
    <MuiIconButton
      ref={ref}
      title={title}
      aria-label={title}
      sx={styles}
      loading={loading}
      data-action-name={`${dataDogIdentifier} icon button`}
      {...props}
    >
      {children}
    </MuiIconButton>
  );
});

IconButton.displayName = "IconButton";

export default IconButton;
